<template>
  <div>
    <NavBar />
    <div v-if="!store.loadedLimitsInfo" class="my-6">
      <span class="loader"></span>
    </div>
    <div v-else>
      <div>
        <div class="font-[sans-serif] max-w-sm mx-auto mt-10 mb-2">
          <form @submit.prevent="uploadFiles" class="mx-4">
            <input
              type="file"
              ref="fileInput"
              multiple
              class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded"
              required
            />
            <p class="text-xs text-gray-400 my-2">Only JPG are allowed</p>
            <div v-if="store.usageLimit !== null && store.usageCount !== null && store.usageCount >= store.usageLimit && store.paymentLink">
              <a
                :href="store.paymentLink"
                class="button-50 bg-black text-white mt-4 py-3 font-semibold text-base rounded hover:bg-gray-800 w-full"
                >Upgrade subscription</a
              >
            </div>
            <button
              v-else
              type="submit"
              class="w-full bg-transparent hover:bg-black text-black font-semibold hover:text-white my-3 py-2 px-4 text-sm border border-black hover:border-transparent rounded"
            >
              Upload and Generate
            </button>
          </form>
        </div>

        <div v-if="results.length" class="max-w-sm mx-auto">
          <div
            v-for="result in results"
            :key="result.file"
            class="result__container mx-4"
          >
            <div class="result mb-8">
              <div class="result__pair">
                <!-- <img
                  v-if="result.fileUrl"
                  :src="result.fileUrl"
                  alt="Uploaded File"
                  class="result__image"
                />
                <div v-else class="result__blank mb-4 w-full"></div> -->

                <div v-if="result.outputUrl" class="w-full">
                  <img
                    :src="result.outputUrl"
                    alt="Output Diagram"
                    class="result__image"
                  />
                  <button
                    @click="downloadFile(result.outputUrl)"
                    class="w-full bg-transparent hover:bg-black text-black font-semibold hover:text-white my-3 py-2 px-4 text-sm border border-black hover:border-transparent rounded"
                  >
                    Download
                  </button>
                </div>
                <p
                  v-else-if="!result.outputUrl && result.error"
                  class="text-red-500 mb-4 my-2"
                >
                  {{ result.error }}
                </p>
                <div v-else class="result__blank mb-4 w-full"></div>
              </div>
            </div>
            <div class="messages">
              <p v-for="message in result.messages" :key="message">
                {{ message }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-modal">
      <span class="loader"></span>
      <p>Please give me a moment</p>
    </div>
  </div>
</template>

<script>
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { useMainStore } from "@/store";
import NavBar from "@/components/NavBar.vue";

export default {
  name: "IndexPage",
  components: {
    NavBar,
  },
  data() {
    return {
      loading: false,
      results: [],
    };
  },
  setup() {
    const store = useMainStore();
    return { store };
  },
  methods: {
    async uploadFiles() {
      this.loading = true;
      try {
        const files = this.$refs.fileInput.files;
        const formData = new FormData();
        for (const file of files) {
          formData.append("files", file);
        }

        const response = await fetch(
          `${process.env.VUE_APP_DIAGRAM_GENERATION_API_URL}/api/generate`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.store.userToken}`,
            },
            body: formData,
          }
        );

        if (!response.ok) {
          const data = await response.json();
          console.log(data);
          throw new Error(`Error: ${data["detail"]}`);
        }

        const results = await response.json();

        this.results = results["conversions"];
        this.store.usageCount = results["usage_count"];

        for (const result of this.results) {
          if (result.file) {
            result.fileUrl = await this.getFileUrl(result.file);
          }
          if (result.output) {
            result.outputUrl = await this.getFileUrl(result.output);
          }
        }
      } catch (error) {
        alert(error.message);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async getFileUrl(storage_path) {
      const storage = getStorage();
      const starsRef = ref(storage, storage_path);

      try {
        const url = await getDownloadURL(starsRef);
        return url;
      } catch (error) {
        switch (error.code) {
          case "storage/object-not-found":
            break;
          case "storage/unauthorized":
            break;
          case "storage/canceled":
            break;
          case "storage/unknown":
            break;
        }
      }
    },
    async downloadFile(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const newUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = newUrl;
      a.download = "diagram.svg";
      a.click();
      window.URL.revokeObjectURL(newUrl);
    },
  },
};
</script>

<style>
header button {
  max-height: 2.5rem;
}

input {
  margin: 5px;
  padding: 8px;
  font-size: 16px;
}
button {
  margin: 5px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
}

.error {
  color: red;
}

.result {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 576px;
}
.result__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.result__pair {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.result__image {
  max-width: 100%;
  margin: 0;
}
.result__blank {
  background-color: #f5f8fc;
  -webkit-box-shadow: 0 0 transparent, 0 0 transparent,
    0 0.375rem 0.375rem -0.125rem rgba(168, 179, 207, 0.4);
  box-shadow: 0 0 transparent, 0 0 transparent,
    0 0.375rem 0.375rem -0.125rem rgba(168, 179, 207, 0.4);
  padding: 0.5rem;
  border-radius: 1rem;
  border: 1px solid rgba(82, 88, 102, 0.2);
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  height: auto;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-width: 80%;
  min-height: 200px;
  animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 80%);
  }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
}

.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
}
.loader {
  width: 1.4rem;
  height: 1.4rem;
  margin-right: 0.5rem;
  border: 0.17rem solid #fff;
  border-bottom-color: #0088ff;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: "Roboto", arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition: background-color 0.218s, border-color 0.218s,
    box-shadow 0.218s;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  -webkit-flex-grow: 1;
  flex-grow: 1;
  font-family: "Roboto", arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  -webkit-transition: opacity 0.218s;
  transition: opacity 0.218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}

/** https://getcssscan.com/css-buttons-examples */

.button-50 {
  text-decoration: none;
  appearance: button;
  background-color: #000;
  background-image: none;
  border: 1px solid #000;
  border-radius: 4px;
  box-shadow: #fff 4px 4px 0 0, #000 4px 4px 0 1px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: ITCAvantGardeStd-Bk, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0 5px 10px 0;
  overflow: visible;
  padding: 12px 40px;
  text-align: center;
  text-transform: none;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.button-50:focus {
  text-decoration: none;
}

.button-50:hover {
  text-decoration: none;
}

.button-50:active {
  box-shadow: rgba(0, 0, 0, 0.125) 0 3px 5px inset;
  outline: 0;
}

.button-50:not([disabled]):active {
  box-shadow: #fff 2px 2px 0 0, #000 2px 2px 0 1px;
  transform: translate(2px, 2px);
}

@media (min-width: 768px) {
  .button-50 {
    padding: 12px 50px;
  }
}
</style>
